const BACK_SOURCE_KEY = 'user-management-back-source'
const APP_BACK_PREFIX = 'app:'
const DEFAULT_APP_BACK_PATH = '/landing-page'

export const markUserManagementOpenedFromApp = (returnPath = DEFAULT_APP_BACK_PATH) => {
  sessionStorage.setItem(BACK_SOURCE_KEY, `${APP_BACK_PREFIX}${returnPath}`)
}

export const getUserManagementAppBackPath = () => {
  const source = sessionStorage.getItem(BACK_SOURCE_KEY) || ''

  if (!source.startsWith(APP_BACK_PREFIX)) {
    return DEFAULT_APP_BACK_PATH
  }

  return source.slice(APP_BACK_PREFIX.length) || DEFAULT_APP_BACK_PATH
}

export const clearUserManagementBackSource = () => {
  sessionStorage.removeItem(BACK_SOURCE_KEY)
}
